import React from "react";
import styles from "./styles.module.scss";
import { SpaceSelectProps } from "./index.types";
import no_space_png from "app/images/null-training-space.png";
import UserAvatar from "app/components/UserAvatar";
import { cls } from "app/utils";
import useSpaceSelectModal from "./indexModel";
import SpaceModel from "app/models/SpaceModel";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import ApplyTemplateListsModal from "../ApplyTemplateListsModal";

const SpaceSelectModal = ({
  onClose,
  isOpen,
  templateId,
}: SpaceSelectProps) => {
  const {
    spaceSelectHandler,
    cancelHandler,
    applyHandler,
    onSearchSpace,
    searchTerm,
    results,
    selectedSpacesId,
  } = useSpaceSelectModal({ onClose, templateId });

  const space = useSelector((state: RootState) => state.space);

  if (!isOpen) {
    return null;
  }

  return (
    <ApplyTemplateListsModal
      pending={space.pending || space.data == null}
      applyHandler={applyHandler}
      cancelHandler={cancelHandler}
      hasNoResult={
        searchTerm.length === 0 &&
        space &&
        space.data &&
        space.data.length === 0
      }
      noResultImage={no_space_png}
      noResultTitle="No Spaces"
      noResultSubText="You don't have created a space yet"
      isOpen={isOpen}
      onClose={onClose}
      searchPlaceholder="Search Space..."
      onSearchChange={onSearchSpace}
      modalSubTitle="You can apply this Template to the Space and posts will be added in the set interval and order"
    >
      <div className={styles.space_list_container}>
        {results &&
          results.map((space: SpaceModel) => {
            return (
              <div
                key={space.id}
                className={cls(styles.space_container, {
                  [styles.disabled]: !space.planPermissions.includes("post"),
                })}
                onClick={() =>
                  space.planPermissions.includes("post")
                    ? spaceSelectHandler(space.id as string, space)
                    : null
                }
              >
                <div className={styles.avatar}>
                  <UserAvatar
                    sizeWidth={44}
                    sizeHeight={44}
                    className="avatar"
                    userName={space.ownerName}
                    srcName={space.avatar as string}
                    altName={space.name}
                  />
                </div>
                <div className={styles.space}>
                  <div className={cls(styles.space_title, styles.elipsis)}>
                    {space.athleteName}
                  </div>
                  <div className={cls(styles.space_subtitle, styles.elipsis)}>
                    {space.sport}
                  </div>
                </div>
                <span className={styles.checkbox}>
                  {selectedSpacesId.includes(space.id) ? (
                    <i className={cls("fas fa-check-circle", styles.checked)} />
                  ) : (
                    <i className={cls("far fa-circle", styles.unchecked)} />
                  )}
                </span>
              </div>
            );
          })}
      </div>
    </ApplyTemplateListsModal>
  );
};

export default SpaceSelectModal;
